import {mapGetters, mapState} from "vuex";

require('./bootstrap');

//Kanban
import vueKanban from 'vue-kanban';


// Importar Biblioteca VueJS
import Vue from "vue";
import { VueEditor } from 'vue2-editor'
Vue.component(VueEditor)
// Componente pai da aplicação VueJS
import App from "./App.vue";

// VueRouter
import {routes} from "./router";
import VueRouter from "vue-router";

// Vuex
import store from "./store";

// VueMq Responsive Vue.JS Breakpoints
import VueMq from 'vue-mq';

// Breakpoints
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity,
  }
})

//import primevue
import PrimeVue from 'primevue/config';

// Bootstrap
import "bootstrap";

// PopperJS
import "popper.js";

// jQuery
import "jquery";

//Vue ics
import ICS from 'vue-ics'

// BootstrapVue
import "bootstrap-vue";
import {BootstrapVue, IconsPlugin} from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Use BootstrapVue
Vue.use(BootstrapVue);

//use vueKanban
Vue.use(vueKanban);

//use Primevue
Vue.use(PrimeVue);

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

//Use Vue Ics
Vue.use(ICS)

// PortalVue
import PortalVue from "portal-vue";

// Use PortalVue
Vue.use(PortalVue);

// SweetAlert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

// iziToast
import 'izitoast/dist/css/iziToast.min.css';
import 'izitoast/dist/js/iziToast.min.js';

// Moment JS
Vue.use(require('vue-moment'));

// Vuetify
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

// Codes Snipets
import VueCodeHighlight from "vue-code-highlight";

Vue.use(VueCodeHighlight);

// CKEditor
// import CKEditor from '@ckeditor/ckeditor5-vue2';
// Vue.use( CKEditor );

import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg, {
  hideModules: {
    "image": true,
    "table": true,
    "link": true,
    "headings": true,
    "code": true,
    "removeFormat": true,
    "separator": true,
  },
  forcePlainTextOnPaste: true,
});
import "vue-wysiwyg/dist/vueWysiwyg.css";

// BoxIcons
import "boxicons";
import "boxicons/css/boxicons.min.css";

// FontAwesome
// import "@fortawesome/fontawesome-free";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
// import "@fortawesome/fontawesome-free/css/brands.min.css";
import "@fortawesome/fontawesome-free/js/brands.min";
// import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/fontawesome.min.js";
import '@flaticon/flaticon-uicons/css/all/all.css';

// Layout
import "./assets/css/style.css";
import "./assets/css/custom.css";
import "./assets/css/responsive.css";
import "./assets/css/animations.scss"
import "./assets/fonts/product-sans/style.css";
import "./assets/css/dark.css";

// ZingchartVue
import 'zingchart/es6';
import zingchartVue from 'zingchart-vue';

// FullCalendar 2.5.0
// (https://fullcalendar.io/docs/v3)
import FullCalendar from 'vue-full-calendar'
import "fullcalendar/dist/fullcalendar.min.css";

Vue.use(FullCalendar)

// V-Money
import money from 'v-money'
Vue.use(money)

Vue.mixin({
  data(){
    return {}
  },
  computed: {
    ...mapState([
      'baileys_integration',
      'bots',
      'campaigns',
      'channels',
      'chat',
      'configs',
      'conversations',
      'dashboard',
      'departments',
      'funnels',
      'goals',
      'histories',
      'interests',
      'categories',
      'lead_requests',
      'lead_quotes',
      'lead_tags',
      'leads',
      'logs',
      'me',
      'motives',
      'notes',
      'notifications',
      'operators',
      'replies',
      'reports',
      'sources',
      'tags',
      'tasks',
      'templates',
      'tickets',
      'tokens',
      'translations',
      'users',
      'wallets',
      'widgets',
      'groups',
      'kanban_columns',
      'kanban_cards',
      'activities',
      'products',
      'product_categories',
      'product_brands',
      'product_suppliers',
      'gallery',
      'reports_opportunities',

    ]),
    ...mapGetters([
      'getChannelObject',
      'getChannelTelegramObject',
      'getChatTicketsFilter',
      'getChatTicketObject',
      'getChannelsArray',
      'getGalerryChannelsAvailableArray',
      'getCampaignsChannelsAvailableArray',
      'getCampaignsFilterOfficialChannelArray',
      'getChannelsFilterNoOfficialAndAvailableArray',
      'getDepartmentObject',
      'getDepartmentsArray',
      'getHistoriesArray',
      'getInterestObject',
      'getLeadCampaignsObject',
      'getLeadObject',
      'getMotiveObject',
      'getOperatorObject',
      'getOperatorsArray',
      'getPublicTranslations',
      'getTagObject',
      'getTagsArray',
      'getTicketObject',
      'getTranslations',
      'getUserObject',
      'getUserOnlineObject',
      'getUsersArray',
      'getWizardObject',
      'getGroupObject',
      'getGroupsArray',
      'filterDepartmentsAvailable',
      'filterOperatorsAvailable',
      'filterDepartmentsAvailableOnActivities',
      'filterOperatorsAvailableOnActivities',
      'filterDepartmentsAvailableOnCampaigns',
      'filterUsersAvailableOnCampaigns',
      'filterDepartmentsAvailableOnChat',
      'filterDepartmentsAvailableOnProducts',
      'filterTagsAvailableOnChat',
      'filterPipelinesAvailableOnChat',
      'getKanbanCardsFilter',
    ]),
  },
  created() {
    // Verifica se é testador
    this.isTester();
    // console.log('Is tester? ', this.isTester())
  },
  mounted() {
    if (this.isTester()){
      // Se for testardor, verifica os passos do Wizard
      this.wizard()
      // console.log('Wizard? ', this.configs.wizard_step)
    }
    window.router = this.$router;
    window.route = this.$route;
  },
  methods: {
    xeroxHelper(payload) {
      return JSON.parse(JSON.stringify(payload))
    },
    downScrollChat() {
      setTimeout(() => {
        document.getElementById('chat_conversation').scrollIntoView({block: "end", behavior: "smooth"});
      }, 500);
    },
    debug(payload) {
      return console.log('Degubber: ', payload)
    },
    revertString(payload){
      return payload.split('-').reverse().join('/');
    },
    isTester(){
      // return ['127.0.0.1'].includes(window.location.hostname) // Desenvolvimento
      return ['192.168.15.125', 'app.beecrm.io'].includes(window.location.hostname)
    },
    wizard(){
      if (window.localStorage.getItem("wizard_step") && window.localStorage.getItem("wizard_step") !== null) {
        this.configs.wizard_step = window.localStorage.getItem("wizard_step")
      } else {
        window.localStorage.setItem("wizard_step", null)
      }
    }
  },
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('truncate', function (value, size) {
  if (!value) return '';
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + '...';
});

Vue.component('zingchart', zingchartVue)

//VueCarousel
import VueCarousel from 'vue-carousel';

Vue.use(VueCarousel);

// VEmojiPicker
import VEmojiPicker from 'v-emoji-picker';

Vue.use(VEmojiPicker);

if (window.app_env === 'production') {
  Vue.config.productionTip = true
  Vue.config.silent = true
  Vue.config.devtools = false
} else {
  Vue.config.productionTip = false
  Vue.config.silent = false
  Vue.config.devtools = true
}

// Vue JS
window.Vue = require('vue');

Vue.component('Layout', require('./views/Theme.vue').default);

// VueRouter
Vue.use(VueRouter);

process.env.BOOTSTRAP_VUE_NO_WARN = true;

// Habilitado modo "history" nas rotas
const router = new VueRouter({
  mode: 'history',
  routes
});

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true
});
// Instancia Vue
const app = new Vue({
  el: '#app',
  store,
  router,
  vuetify: new Vuetify(),
  render: h => h(App),
});

